"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const draftjs_to_html_1 = tslib_1.__importDefault(require("draftjs-to-html"));
const moment_1 = tslib_1.__importDefault(require("moment"));
const react_1 = tslib_1.__importStar(require("react"));
const react_components_1 = require("@apollo/react-components");
const react_json_view_1 = tslib_1.__importDefault(require("react-json-view"));
const react_router_dom_1 = require("react-router-dom");
const reactstrap_1 = require("reactstrap");
const context_1 = require("../../../context");
const reusables_1 = require("../../../comps/reusables");
const graphql_1 = require("../../../graphql");
const LayoutVisualizer_1 = require("./LayoutVisualizer");
const DeployButton_1 = require("./DeployButton");
const AdminOnly_1 = require("../../../comps/reusables/AdminOnly");
const react_if_1 = require("react-if");
const react_hanger_1 = require("react-hanger");
const utils_1 = require("@osmosys/utils");
const react_2 = require("@osmosys/react");
const NewEmailView_1 = require("../Emails/EmailHome/NewEmailView");
const hooks_1 = require("../../../hooks");
// const NewEmailButton = ({
//   emailTemplate,
//   emailTemplateVersion,
// }: {
//   emailTemplate: EmailTemplate;
//   emailTemplateVersion: EmailTemplateVersion;
// }) => {
//   return (
//     <OsmosysButton
//       osysName="NewEmailButton"
//       to={`/emails/new?template=${emailTemplate.id}&version=${emailTemplateVersion.version}`}
//       openInNewTab
//       outline
//       size="sm"
//     >
//       New email
//     </OsmosysButton>
//   );
// };
// <IProps, IState>
exports.EmailTemplateVersionDetail = ({ hideVersion, useCard, data, }) => {
    //   public static getDerivedStateFromProps(props, state) {
    //     if (props.data.releaseNotes) {
    //       let releaseNotesHTML: string;
    //       try {
    //         releaseNotesHTML = draftToHtml(JSON.parse(props.data.releaseNotes));
    //       } catch (e) {
    //         console.warn('Invalid releaseNotes: ', e);
    //         return {
    //           releaseNotesHTML:
    //             '<p>There was an error loading release notes. \
    // They may not have been saved properly.</p>',
    //         };
    //       }
    //       // TODO: Can I clean this up before saving to the database?
    //       releaseNotesHTML = releaseNotesHTML.trim();
    //       releaseNotesHTML = releaseNotesHTML.replace(
    //         '<p style="text-align:start;"></p>',
    //         ''
    //       );
    //       return {
    //         ...state,
    //         releaseNotesHTML,
    //       };
    //     }
    //     return null;
    //   }
    const releaseNotesHTML = react_1.useMemo(() => {
        try {
            return draftjs_to_html_1.default(JSON.parse(data.releaseNotes));
        }
        catch (e) {
            console.warn('Invalid releaseNotes: ', e);
            return '<p>There was an error loading release notes. They may not have been saved properly.</p>';
        }
    }, [data.releaseNotes]);
    const { state, setState } = react_hanger_1.useSetState({
        clickedSaveAndClose: false,
        clickedSaveAndContinue: false,
        newReleaseNotes: {},
        releaseNotesData: {},
        releaseNotesModalIsFullyClosed: true,
        showBlockData: false,
        showBlockDataClickCount: 0,
        showBlockVisual: false,
        showReleaseNotesModal: false,
        showStaffPanel: false,
    });
    const newReleaseNotesJson = react_1.useMemo(() => {
        try {
            return JSON.stringify(state.newReleaseNotes);
        }
        catch (e) {
            utils_1.logger.error({ error: e }, 'Failed to parse release notes raw state');
            return JSON.stringify(state.newReleaseNotes);
        }
    }, [state.newReleaseNotes]);
    const renderCodePulledFromText = () => {
        if (data.codePulledFrom === 'templateURL') {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                "Code pulled from the default template",
                ' ',
                react_1.default.createElement("a", { target: "_blank", rel: "noopener noreferrer", href: data.url }, "URL")));
        }
        if (data.codePulledFrom === 'versionURL') {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                "Code pulled from an explicitly set",
                ' ',
                react_1.default.createElement("a", { target: "_blank", rel: "noopener noreferrer", href: data.url }, "URL")));
        }
        if (data.codePulledFrom === 'pastedHTML') {
            return react_1.default.createElement(react_1.default.Fragment, null, "Code was provided by user (likely copy and pasted)");
        }
        if (data.codePulledFrom === 'hostedFileURL') {
            return react_1.default.createElement(react_1.default.Fragment, null, "Uploaded using an HTML file");
        }
        if (data.codePulledFrom === 'oceanEditor') {
            return react_1.default.createElement(react_1.default.Fragment, null, "Created using Osmosys");
        }
        return '';
    };
    const openReleaseNotes = e => {
        e.preventDefault();
        setState({
            releaseNotesModalIsFullyClosed: false,
            showReleaseNotesModal: true,
        });
    };
    const { mutation, mutationResult } = hooks_1.useUpdateEmailTemplateVersion(newReleaseNotesJson, data, {
        onCompleted: () => {
            if (state.clickedSaveAndClose) {
                setState({
                    clickedSaveAndClose: false,
                    clickedSaveAndContinue: false,
                });
            }
            else {
                setState({
                    clickedSaveAndClose: false,
                    clickedSaveAndContinue: false,
                    showReleaseNotesModal: false,
                });
            }
        },
    });
    const releaseNotes = releaseNotesHTML ? (react_1.default.createElement("div", { dangerouslySetInnerHTML: { __html: releaseNotesHTML } })) : (react_1.default.createElement("p", null,
        react_1.default.createElement("a", { href: "#", onClick: e => openReleaseNotes(e) },
            "Write release notes ",
            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faArrowRight }))));
    const feedbackSubject = `Problem with version ${data.version} (#${data.id})`;
    const buttons = (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_2.OsmosysDiv, { flexRow: true },
            react_1.default.createElement(react_2.OsmosysDiv, { flexRow: true },
                react_1.default.createElement(NewEmailView_1.NewEmailView, { asLink: true, template: data.template, templateVersion: data })),
            react_1.default.createElement(react_2.OsmosysDiv, { flexRow: true },
                react_1.default.createElement(DeployButton_1.DeployButton, { emailTemplate: data.template, emailTemplateVersion: data, onCompleted: () => { } })))));
    const contents = (react_1.default.createElement(react_1.default.Fragment, null,
        hideVersion !== true && (react_1.default.createElement(reactstrap_1.Row, { className: "mb-3" },
            react_1.default.createElement(reactstrap_1.Col, null,
                react_1.default.createElement("h3", { className: "mb-0" },
                    react_1.default.createElement(react_router_dom_1.Link, { to: `/templates/${data.template.id}/versions/${data.id}`, className: "text-dark" },
                        "Version ",
                        data.version))),
            react_1.default.createElement(reactstrap_1.Col, { className: "flex-grow-0 flex-shrink-0" }, buttons))),
        react_1.default.createElement(reactstrap_1.Row, null,
            react_1.default.createElement(reactstrap_1.Col, null,
                react_1.default.createElement(reactstrap_1.Row, { className: "d-flex" },
                    react_1.default.createElement(reactstrap_1.Col, null,
                        react_1.default.createElement("h5", null, "Release notes")),
                    react_1.default.createElement(reactstrap_1.Col, { className: "flex-grow-0" },
                        react_1.default.createElement("a", { href: "#", onClick: e => openReleaseNotes(e) },
                            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faEdit })))),
                react_1.default.createElement("hr", { className: "mt-0" }),
                releaseNotes),
            react_1.default.createElement(reactstrap_1.Col, null,
                react_1.default.createElement("div", { className: "text-right mb-2" }, hideVersion === true && buttons),
                react_1.default.createElement(reactstrap_1.Table, { borderless: true, className: "my-0" },
                    react_1.default.createElement("tbody", null,
                        react_1.default.createElement("tr", null,
                            react_1.default.createElement("td", { className: "text-center pt-0" },
                                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faCalendar })),
                            react_1.default.createElement("td", { className: "w-100 pt-0" },
                                react_1.default.createElement(react_router_dom_1.Link, { to: `/templates/${data.template.id}/versions/${data.id}` },
                                    "Created ",
                                    moment_1.default(data.createdAt).format('lll')))),
                        react_1.default.createElement("tr", null,
                            react_1.default.createElement("td", { className: "text-center pt-0" },
                                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faBox })),
                            react_1.default.createElement("td", { className: "w-100 pt-0" }, data.deployments && data.deployments.length ? (react_1.default.createElement(react_1.default.Fragment, null,
                                data.deployments.length,
                                ' ',
                                react_1.default.createElement(react_router_dom_1.Link, { to: `/templates/${data.template.id}/deployments` }, `deployment${data.deployments.length === 1 ? '' : 's'}`))) : (`${data.version} has not been deployed`))),
                        react_1.default.createElement("tr", null,
                            react_1.default.createElement("td", { className: "text-center pt-0" },
                                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faUser })),
                            react_1.default.createElement("td", { className: "w-100 pt-0" },
                                "Created by",
                                ' ',
                                data.creatingUser ? (react_1.default.createElement(react_router_dom_1.Link, { to: `/admin/users/${data.creatingUser.id}` }, data.creatingUser.fullName || data.creatingUser.email)) : (react_1.default.createElement("span", { className: "text-muted" }, "Unknown")))),
                        react_1.default.createElement("tr", null,
                            react_1.default.createElement("td", { className: "text-center pt-0" },
                                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faCode })),
                            react_1.default.createElement("td", { className: "w-100 pt-0" }, renderCodePulledFromText())),
                        react_1.default.createElement("tr", null,
                            react_1.default.createElement("td", { className: "text-center pt-0" },
                                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faSquare })),
                            react_1.default.createElement("td", { className: "w-100 pt-0" }, !data.blocks || data.blocks.length === 0 ? (' No blocks found') : (react_1.default.createElement("span", { onClick: () => {
                                    if (state.showBlockDataClickCount > 2) {
                                        setState({
                                            showBlockData: true,
                                            showBlockDataClickCount: 0,
                                        });
                                    }
                                    else {
                                        setState({
                                            showBlockDataClickCount: 1 + state.showBlockDataClickCount,
                                        });
                                    }
                                } },
                                data.blocks.length,
                                " block",
                                data.blocks.length === 1 ? '' : 's')))),
                        react_1.default.createElement("tr", null,
                            react_1.default.createElement("td", { className: "text-center pt-0" },
                                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faArrowAltCircleDown })),
                            react_1.default.createElement("td", { className: "w-100 pt-0" },
                                react_1.default.createElement("a", { download: true, href: `/api/v1/downloads/email-template-versions/${data.id}` }, "Download"))),
                        react_1.default.createElement("tr", null,
                            react_1.default.createElement("td", { className: "text-center py-0" },
                                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faExclamationCircle })),
                            react_1.default.createElement("td", { className: "w-100 py-0" },
                                react_1.default.createElement("a", { href: `mailto:support@yellowbrim.com?subject=${encodeURIComponent(feedbackSubject)}` }, "Report a problem"))),
                        react_1.default.createElement(context_1.OsmosysAppContext.Consumer, null, ({ adminRole }) => {
                            if (adminRole !== 'app') {
                                return react_1.default.createElement(react_1.default.Fragment, null);
                            }
                            return (react_1.default.createElement("tr", null,
                                react_1.default.createElement("td", { className: "text-center pb-0" },
                                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faLock })),
                                react_1.default.createElement("td", { className: "w-100 pb-0" },
                                    react_1.default.createElement("a", { href: "#", onClick: e => {
                                            e.preventDefault();
                                            setState({
                                                showStaffPanel: !state.showStaffPanel,
                                            });
                                        } }, "App admin options"))));
                        }))))),
        react_1.default.createElement(react_if_1.When, { condition: !!state.showStaffPanel },
            react_1.default.createElement(AdminOnly_1.AdminOnly, null,
                react_1.default.createElement(reactstrap_1.Row, null,
                    react_1.default.createElement(reactstrap_1.Col, { className: "text-center" },
                        react_1.default.createElement(reusables_1.AdminsOnlyHeader, { isAppAdmin: true }),
                        react_1.default.createElement(reactstrap_1.Button, { className: "mx-1", tag: react_router_dom_1.Link, size: "sm", to: `/templates/editor?template=${data.template.id}&version=${data.version}`, color: "light" }, "Open in template editor"),
                        react_1.default.createElement(react_components_1.Query, { query: graphql_1.emailTemplateVersion, variables: { emailTemplateId: data.template.id, id: data.id }, skip: !data.id || !data.template.id }, visualDetails => {
                            if (visualDetails.loading) {
                                return (react_1.default.createElement(reactstrap_1.Button, { className: "mx-1", color: "light", size: "sm", disabled: true }, "Loading"));
                            }
                            if (visualDetails.error ||
                                !visualDetails.data ||
                                !visualDetails.data.emailTemplateVersion) {
                                return (react_1.default.createElement(reactstrap_1.Button, { className: "mx-1", color: "light", size: "sm", disabled: true }, "Failed to load blocks"));
                            }
                            if (!visualDetails.data.emailTemplateVersion.blocks ||
                                visualDetails.data.emailTemplateVersion.blocks.length === 0) {
                                return (react_1.default.createElement(reactstrap_1.Button, { className: "mx-1", color: "light", size: "sm", disabled: true }, "No blocks found"));
                            }
                            return (react_1.default.createElement(react_1.default.Fragment, null,
                                react_1.default.createElement(reactstrap_1.Button, { className: "mx-1", color: "light", size: "sm", onClick: () => {
                                        setState({
                                            showBlockVisual: true,
                                        });
                                    } }, "Show blocks"),
                                react_1.default.createElement(LayoutVisualizer_1.LayoutVisualizer, { toggle: showBlockVisual => {
                                        setState({
                                            showBlockVisual,
                                        });
                                    }, isOpen: state.showBlockVisual, blocks: visualDetails.data.emailTemplateVersion.blocks })));
                        }),
                        react_1.default.createElement(reactstrap_1.Button, { className: "mx-1", tag: "a", download: true, size: "sm", href: `/api/v1/downloads/email-template-versions/${data.id}?parsedHTML=true`, color: "light" }, "Download parsed HTML"),
                        react_1.default.createElement(reactstrap_1.Button, { className: "mx-1", color: "light", size: "sm", onClick: () => {
                                setState({
                                    showBlockData: !state.showBlockData,
                                });
                            } }, state.showBlockData ? 'Hide data' : 'Show data'),
                        data.screenshot && (react_1.default.createElement(reactstrap_1.Button, { className: "mx-1", color: "light", size: "sm", href: data.screenshot.url, tag: "a" }, "Screenshot")),
                        ' ')),
                state.showBlockData && (react_1.default.createElement(reactstrap_1.Row, { className: "mt-4" },
                    react_1.default.createElement(reactstrap_1.Col, null,
                        react_1.default.createElement(react_json_view_1.default, { collapseStringsAfterLength: 200, src: data })))))),
        (state.showReleaseNotesModal ||
            !state.releaseNotesModalIsFullyClosed) && (react_1.default.createElement(reusables_1.TextEditor, { data: data.releaseNotes, onChange: rawContentState => {
                setState({
                    newReleaseNotes: rawContentState,
                });
            }, onClosed: () => {
                setState({
                    releaseNotesModalIsFullyClosed: true,
                });
            }, unMountOnModalClose: true, isModal: true, isOpen: state.showReleaseNotesModal, modalHeader: `Release notes for ${data.version}`, modalBodyFooter: react_1.default.createElement(react_2.OsmosysErrorAlert, { resource: "EmailTemplateVersion", action: "update", apolloError: mutationResult.error }), modalFooter: react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(reactstrap_1.Button, { color: "light", className: "mr-auto", onClick: () => setState({ showReleaseNotesModal: false }) }, "Cancel"),
                ' ',
                react_1.default.createElement(reactstrap_1.ButtonGroup, null,
                    react_1.default.createElement(reusables_1.AjaxButton, { label: "Save", loading: state.clickedSaveAndClose && !!mutationResult.loading, error: state.clickedSaveAndClose && !!mutationResult.error, success: state.clickedSaveAndClose && !!mutationResult.data, disabled: state.clickedSaveAndContinue || !!mutationResult.loading, onClick: () => {
                            setState({
                                clickedSaveAndClose: true,
                                clickedSaveAndContinue: false,
                            });
                            mutation();
                        } }))), toggle: () => {
                setState({
                    showReleaseNotesModal: !state.showReleaseNotesModal,
                });
            } }))));
    if (useCard) {
        return react_1.default.createElement(reactstrap_1.Card, { body: true }, contents);
    }
    return contents;
};
//# sourceMappingURL=EmailTemplateVersionDetail.js.map